/**
 * @author: lihuimin25
 * @description: 日常活动 - 规则圈选 - 商品策略list
 */
import { Table, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import React, { useState, useEffect, useContext } from 'react';
import { copy, getQuery } from '@/common/utils';
import { queryGoodsStrategyList, GoodsStrategyItem } from '@/apis/marketingField/materialCollection';
import TableContactUser from '@/pages/platform-marketing-position/detail/material-pool-manage/views/components/table-contact-user';
import { ACTASSIGNTYPEENUM } from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection/sale-strategy-list/list-hooks';
import { newPandoraLink, newPandoraConfig } from '@/micro-app/context/new-pandora-config';
import './list.less';

const prefix = 'act_product-strategy-0331';
const PAGESIZE = 10;

const ProductStrategyList = () => {
  const [strategyList, setStrategyList] = useState<GoodsStrategyItem[]>([]);
  const [pagination, setPagination] = useState({
    defaultCurrent: 1,
    current: 1,
    pageSize: PAGESIZE,
    total: 0,
  });

  const handleCopy = (id: number) => {
    const result = copy(id.toString());
    if (result) {
      message.info('复制成功!');
    }
  };

  const newPoolTypes = useContext(newPandoraConfig);

  const jumpToPandora = (id: number, name: string) => {
    const roomId = getQuery('roomId'),
      blockId = getQuery('blockId');
    const activityId = getQuery('activityId');
    if (!activityId) {
      message.info('请检查是否有活动ID');
      return;
    }
    const defaultRules = [
      {
        ruleCode: 'taskId',
        ruleName: '商品策略',
        value: [
          {
            value: id,
            label: name,
          },
        ],
      },
    ];
    const oldLink = `/pandoraacore/#/integration/manage/45?jumpTo=WDSC&outId=${roomId}&resourceId=${blockId}&activityType=11&defaultRules=${JSON.stringify(
      defaultRules
    )}&yxActivityId=${activityId}`;
    const newLink = `/selection/#/selection/manage/45?jumpTo=WDSC&outId=${roomId}&resourceId=${blockId}&activityType=11&defaultRules=${JSON.stringify(
      defaultRules
    )}&yxActivityId=${activityId}`;

    const link = newPandoraLink(45, newPoolTypes, oldLink, newLink);

    window.open(link);
  };

  const columns = [
    {
      title: '商品策略/ID',
      dataIndex: 'id',
      width: 250,
      render: (text: string, record: GoodsStrategyItem) => {
        return (
          <div className={`${prefix}-tactics`}>
            <span className="name" title={record.jobName}>
              {record.jobName}
            </span>
            <span className="tactics_id">{record.jobId}</span>
            <span onClick={() => handleCopy(record.jobId)} style={{ cursor: 'pointer' }}>
              <CopyOutlined />
            </span>
          </div>
        );
      },
    },
    {
      title: '类型',
      dataIndex: 'type',
      width: 100,
      render: (value: GoodsStrategyItem['type']) => ACTASSIGNTYPEENUM[value],
    },
    {
      title: '商品数',
      dataIndex: 'wareCount',
      width: 100,
      render: (text: string) => <div title={text}>{text || '-'}</div>,
    },
    {
      title: '创建人',
      dataIndex: 'createdByCN',
      width: 120,
      render: (text: string, record: GoodsStrategyItem) => {
        return <TableContactUser userName={record.createdByCN} userErp={record.createBy} />;
      },
    },
    {
      title: '策略说明',
      dataIndex: 'jobDescription',
      width: 100,
      render: (text: string) => (
        <div className={`${prefix}-description`} title={text}>
          {text}
        </div>
      ),
    },
    {
      title: '操作',
      width: 100,
      render: (text: string, record: GoodsStrategyItem) => {
        return <a onClick={() => jumpToPandora(record.jobId, record.jobName)}>去选品</a>;
      },
    },
  ];

  const queryStrategyList = async (page: number) => {
    const param = {
      channelId: getQuery('roomId') || '',
      channelType: 11, // 9-阵地；11-日常活动
      pageNo: page,
      pageSize: PAGESIZE,
    };
    const res = await queryGoodsStrategyList(param);
    if (res.ret === '0' && res.data) {
      setStrategyList([...res.data.data]);
    }
  };

  const onPaginationChange = (page: number) => {
    setPagination((pre) => ({ ...pre, current: page }));
    queryStrategyList(page);
  };

  useEffect(() => {
    queryStrategyList(1);
  }, []);

  const renderRuleCollection = () => {
    return (
      <div className={`${prefix}-rule-part`}>
        <div className={`${prefix}-table`}>
          <Table
            columns={columns}
            dataSource={strategyList}
            pagination={{
              ...pagination,
              total: pagination.total,
              showSizeChanger: false,
              showTotal: (total) => `总共${total}条`,
              onChange: onPaginationChange,
            }}
          />
        </div>
      </div>
    );
  };

  return <div className={`${prefix}-wrapper`}>{renderRuleCollection()}</div>;
};

export default ProductStrategyList;
